export default {
  install(Vue, options) {
    Vue.prototype.$urlParamProcess = (obj) => {
      // 处理访问链接中带applySource=appmzt的参数
      const ua = navigator.userAgent;
      if (/mzt/.test(ua)) {
        return obj.url;
      } else if (/MicroMessenger/.test(ua)) {
        let url = obj.url;
        if (obj.wxUrl !== null && obj.wxUrl !== undefined && obj.wxUrl !== '') {
          url = obj.wxUrl;
        } else {
          url = url.replace("applySource=appmzt", "applySource=wxmzt");
        }
        return url;
      } else if (/AlipayClient/.test(ua)) {
        let url = obj.url;
        url = url.replace("applySource=appmzt", "applySource=zfbmzt");
        return url;
      } else {
        let url = obj.url;
        if (obj.wxUrl !== null && obj.wxUrl !== undefined && obj.wxUrl !== '') {
          url = obj.wxUrl;
        } else {
          url = url.replace("applySource=appmzt", "applySource=wxmzt");
        }
        return url;
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/plugins/urlParamProcess.js